import React from 'react';

interface GlobalContextType {
  isMobile: boolean;
}

export default React.createContext<GlobalContextType>({ isMobile: false });
